"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaVisualizationDataEntity = void 0;
class MediaVisualizationDataEntity {
    id;
    display;
    media;
    mediaCampaign;
    dates;
    createdAt;
    updatedAt;
}
exports.MediaVisualizationDataEntity = MediaVisualizationDataEntity;
